import { render, staticRenderFns } from "./QCheckBoxGroup.vue?vue&type=template&id=86707304&"
import script from "./QCheckBoxGroup.vue?vue&type=script&lang=js&"
export * from "./QCheckBoxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports